module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "scale"
    }
  }, [(_vm.isVisible) ? _c('div', {
    staticClass: "notification"
  }, [_c('span', {
    staticClass: "h6 regular c-light"
  }, [_vm._v(_vm._s(_vm.message))])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7c779a8b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./app/components/elements/Notification.vue
// module id = 649
// module chunks = 0